<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
          <h1 class="tac login_big">Sign up</h1>
        </div>
      </div>

      <div class="row">
        <div class="col_xl_4 xl_offset_2 col_l_4 l_offset_2 col_m_6 col_s_6">
          <button
              class="colored_btn social_login hover_op first"
              v-on:click="loginWithGoogle"
          >
            Sign up w/ Google
          </button>
        </div>

        <div class="col_xl_4 col_l_4 col_m_6 col_s_6">
          <button
              class="colored_btn social_login hover_op last"
              v-on:click="loginWithFacebook"
          >
            Sign up w/ Facebook
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
          <p class="tac login_medium">Or</p>
        </div>
      </div>

      <div class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12">
        <form v-on:submit="signUpWithEmailPassword">
          <div class="row">
            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <inputWrap
                  :title="'First & last name'"
                  :type="'text'"
                  :placeholder="'Edith Anderson'"
                  :name="'name'"
                  :id="'name'"
                  :required="true"
                  :inputData.sync="name"
              ></inputWrap>
            </div>

            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <inputWrap
                  :title="'Email address'"
                  :type="'email'"
                  :placeholder="'e.g., edithanderson@gmail.com'"
                  :name="'email'"
                  :id="'email'"
                  :required="true"
                  :inputData.sync="email"
                  :hasError="emailError !== ''"
                  :errorText="emailError"
              ></inputWrap>
            </div>

            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <inputWrap
                  :title="'Password'"
                  :type="'password'"
                  :placeholder="'e.g., sfk#211'"
                  :name="'password'"
                  :id="'password'"
                  :required="true"
                  :inputData.sync="password"
                  :hasError="passwordError !== ''"
                  :errorText="passwordError"
              ></inputWrap>
            </div>

            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <div class="df s_betwen login_lover_links_wrap">
                <router-link to="/auth/login" class="login_lover_links hover_op"
                >Already have an account?
                </router-link
                >
                <router-link
                    to="/auth/password-reset"
                    class="login_lover_links hover_op"
                >Forget password?
                </router-link
                >
              </div>
            </div>

            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <input type="submit" value="Sign Up" class="color_btn hover_op"/>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import inputWrap from "@/components/inputWrap.vue";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  updateProfile, FacebookAuthProvider
} from "firebase/auth";

export default {
  name: "SignUp",
  data() {
    return {
      name: "",
      email: "",
      password: "",
      emailError: "",
      passwordError: ""
    };
  },

  components: {
    inputWrap,
  },

  methods: {
    async loginWithGoogle() {
      try {
        this.emailError = ""
        this.passwordError = ""

        const provider = new GoogleAuthProvider();
        const auth = getAuth();
        await signInWithPopup(auth, provider)
        this.$router.push(this.$route.query.returnTo ? this.$route.query.returnTo : "/user_rooms");
      } catch (e) {
        this.$store.dispatch("onError", "An error occurred");
        console.log(e);
      }
    },

    async loginWithFacebook() {
      try {
        this.emailError = ""
        this.passwordError = ""

        const provider = new FacebookAuthProvider();
        const auth = getAuth();
        await signInWithPopup(auth, provider)
        this.$router.push(this.$route.query.returnTo ? this.$route.query.returnTo : "/user_rooms");
      } catch (e) {
        this.$store.dispatch("onError", "An error occurred");
        console.log(e);
      }
    },

    async signUpWithEmailPassword(event) {
      try {
        this.emailError = ""
        this.passwordError = ""

        event.preventDefault();
        await createUserWithEmailAndPassword(getAuth(), this.email, this.password)
            .then((user => updateProfile(user.user, {displayName: this.name})));

        this.$router.push(this.$route.query.returnTo ? this.$route.query.returnTo : "/user_rooms");

      } catch (e) {

        switch (e.code) {
          case "auth/weak-password":
            this.passwordError = "Password should be at least 6 characters"
            break
          case "auth/email-already-in-use":
            this.emailError = "Email address already in use"
            break
          default:
            this.$store.dispatch("onError", "An error occurred");
            console.log(e);
        }

      }
    },
  },
};
</script>

<style scoped>
</style>
